import * as CubeTree from '../../../cubeTree/index';
import { shelfTarget } from './shelfTarget';
import { freezerTarget } from './freezerTarget';
import { partitionTarget } from './partitionTarget';
import { goodsTarget } from './goodsTarget';
import { textareaTarget } from './textareaTarget';
import { bafflePlateTarget } from './bafflePlateTarget';

function findInsertTarget(insertData: FreeObjMap, allSelected: Array<CubeId>): Array<CubeId> {
    if (CubeTree.isShelfCubeData(insertData)) {
        return shelfTarget(allSelected);
    }
    else if (CubeTree.isFreezerCubeData(insertData)) {
        return freezerTarget(allSelected);
    }
    else if (CubeTree.isPartitionCubeData(insertData)) {
        return partitionTarget(allSelected);
    }
    else if (CubeTree.isGoodsCubeData(insertData)) {
        return goodsTarget(allSelected);
    }
    else if (CubeTree.isTextareaCubeData(insertData)) {
        return textareaTarget(allSelected);
    }
    else if (CubeTree.isBafflePlateCubeData(insertData)) {
        return bafflePlateTarget(allSelected);
    }
    else {
        return [];
    }
}

export {
    findInsertTarget
};
